import { trackEvent } from "../analytics";
import { fetchMyInviteLink, inviteAbsoluteUrl } from "../api/briefingInvites";
import { buildMorningBriefingShareMessage, buildWhatsAppSendUrl } from "./whatsAppShare";

/**
 * Fetch reusable invite link and open WhatsApp with briefing prefill.
 * @param {{ sections: Array<{ label: string, text: string }> }} params
 */
export async function shareMorningBriefingViaWhatsApp({ sections }) {
  const { path } = await fetchMyInviteLink();
  const shareUrl = inviteAbsoluteUrl(path);
  trackEvent("share_whatsapp", { scenario: "briefing_invite" });
  const waUrl = buildWhatsAppSendUrl(
    buildMorningBriefingShareMessage({ sections, url: shareUrl })
  );
  const openInNewTab = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  if (openInNewTab) {
    const handle = window.open(waUrl, "_blank");
    if (handle) {
      handle.opener = null;
    } else {
      window.location.href = waUrl;
    }
  } else {
    window.location.href = waUrl;
  }
}

/** Open WhatsApp with invite URL (no briefing sections). */
export function openWhatsAppUrl(url) {
  const openInNewTab = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  if (openInNewTab) {
    const handle = window.open(url, "_blank");
    if (handle) {
      handle.opener = null;
    } else {
      window.location.href = url;
    }
  } else {
    window.location.href = url;
  }
}
